const getEstimatedReturn = (
  userDeposit: number,
  totalSupply: number,
  totalDepositedInUst: number,
) => (totalSupply * userDeposit) / (totalDepositedInUst + userDeposit);

export default getEstimatedReturn;
